import { type ComponentProps } from 'react'
import type { Price } from '@/components/Price'
import type { CurrencyCode } from '@/services/graphql/generated'

type Money = {
  amount: number
  currencyCode: CurrencyCode
}

type Cost = {
  net: Money
  gross: Money
}

export const getSummarisedPrice = (cost: Cost): ComponentProps<typeof Price> => ({
  currencyCode: cost.net.currencyCode,
  amount: cost.gross.amount,
  reducedAmount: cost.gross.amount !== cost.net.amount ? cost.net.amount : undefined,
})
